module.exports = __webpack_public_path__ + "assets/img/license.6e430214.png";